export default __webpack_public_path__ + "static/media/ic_settings_search.99b7f23b.svg";